<template>
  <div id="container">
    <Top :show-user="true"/>
    <div class="body">
      <div class="title">
        Настройки системы (версия 4.9.6)
      </div>
      <div class="block">
        <table test-id="groups_table">
          <thead>
          <tr>
            <th :colspan="users.length + 5">
              Управление резервными группами
            </th>
          </tr>
          <tr>
            <th>
              РГ
            </th>
            <th>
              Метод перехода
            </th>
            <th>
              ПСД опция
            </th>
            <th>
              Тип группы
            </th>
            <th></th>
            <th></th>
          </tr>
          </thead>
          <tbody>
            <tr v-for="group in groups" :key="group.id" class="data-row">
              <td class="period">
                {{ group.name }}
              </td>
              <td class="period">
                {{ group.method_name }}
              </td>
              <td class="period">
                {{ group.model_name }}
              </td>
              <td class="period">
                {{ group.model_type }}
              </td>
              <td>
                <button @click="editGroup(group)">Изменить</button>
              </td>
              <td v-if="![1, 2].includes(group.id)">
                <button @click="deleteGroup(group.id)">Удалить</button>
              </td>
              <td v-else></td>
            </tr>
          </tbody>
        </table>
        <button @click="switchGroupsEditModalState" test-id="add_group_button">Добавить резервную группу</button>
      </div>

      <div class="block">
        <table>
          <thead>
          <tr>
            <th colspan="5">
              Настройки шаблонных методов
            </th>
          </tr>
          <tr>
            <th>
              РГ
            </th>
            <th>
              Тип расчета
            </th>
            <th>
              Шаблонный метод
            </th>
            <th>
              Параметры данных
            </th>
            <th>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="templates.length" v-for="t in templates" :key="t.id" class="data-row">
            <td>
              {{ t.group }}
            </td>
            <td>
              {{ t.type }}
            </td>
            <td>
              {{ t.method }}
            </td>
            <td>
              {{ t.period }},<br>
              {{ t.dimension }} период,<br>
              {{ t.base }},<br>
              {{ t.calc_type }}
            </td>
            <td>
              <button @click="declineTemplate(t.id)">Отклонить</button>
            </td>
          </tr>
          <tr v-else>
            <td colspan="5" class="td-centered">
              Нет шаблонных методов
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="block">
        <table>
          <thead>
          <tr>
            <th>
              Размерность для ДП ограниченная
            </th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td class="check">
              <input type="checkbox" v-model="matrixDynamicSize">
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <teleport to="body">
    <Modal :show="showGroupsEditModal" :controlsAvaliable="true">
      <template #header>
        <div class="modal-header" v-if="editMode">Изменить резервную группу</div>
        <div class="modal-header" v-else="editMode">Добавить новую резервную группу</div>
      </template>
      <template #body>
        <h3 v-if="groupAddErrorMessage">{{ groupAddErrorMessage }}</h3>
        <div class="modal-group-name-input" v-if="!editMode">
          <label for="groupName">Название резерной группы:</label>
          <input type="text" id="groupName" test-id="group_name" v-model="groupName">
        </div>
        <div class="modal-group-name-input">
          <label for="groupMethod">Метод перехода:</label>
          <select id="groupMethod" test-id="group_method" v-model="groupMethod">
            <option value="100" default>MRA</option>
          </select>
        </div>
        <div class="modal-group-name-input">
          <label for="groupModel">ПСД опция</label>
          <select id="groupModel" test-id="group_model" v-model="groupModel">
            <option value="200" default>OCI LI</option>
            <option value="201">OCI None</option>
          </select>
        </div>
        <div class="modal-group-name-input">
          <label for="groupType">Тип группы</label>
          <select id="groupType" test-id="group_type" v-model="groupType">
            <option value="300" default>Прямой бизнес</option>
            <option value="301">Перестрахование</option>
          </select>
        </div>
      </template>
      <template #footer>
        <button @click="changeGroup" test-id="edit_group_button_modal" v-if="editMode">Изменить</button>
        <button @click="addGroup" test-id="add_group_button_modal" v-else>Добавить</button>
        <button @click="switchGroupsEditModalState">Отмена</button>
      </template>
    </Modal>
  </teleport>

</template>

<script>
import Top from "@/components/Top";
import Modal from "@/components/Modal.vue";

export default {
  name: 'Settings',
  components: {
    Top,
    Modal
  },
  data() {
    return {
      users: [],
      groups: [],
      templates: [],
      showGroupsEditModal: false,
      groupId: '',
      groupName: '',
      groupMethod: '100',
      groupModel: '200',
      groupType: '300',
      groupAddErrorMessage: '',
      showClearModal: false,
      editMode: false,
      matrixDynamicSize: true
    }
  },
  mounted() {
    this.loadData()
  },
  watch: {
    matrixDynamicSize(newSize, oldSize) {
      this.updateDynamicMatrixSize(newSize)
    }
  },
  methods: {
    updateDynamicMatrixSize(dynamicSize) {
      this.$http
        .post(`/settings/matrix-size/`, {
          fix_size: dynamicSize
        })
        .then(response => {
          console.log(`Matrix size update`)
        })
        .catch(error => {
          console.log('Error in group edit', error);
        })
    },
    loadData() {
      this.$http
          .get(`/settings`)
          .then(response => {
            this.users = response.data.users
            this.groups = response.data.groups.filter((group) => group.name != 'common')
            this.templates = response.data.templates
            console.log('Settings->loaded(): done')
          })
          .catch(error => console.error('Settings->loaded(): ERROR: ' + error))

      this.$http
          .get(`/settings/matrix-size/`)
          .then(response => {
            this.matrixDynamicSize = response.data.fix_size
            console.log('Settings->loaded(): done')
          })
          .catch(error => console.error('Settings->loaded(): ERROR: ' + error))
    },
    switchGroupsEditModalState() {
      this.showGroupsEditModal = !this.showGroupsEditModal;
      if(!this.showGroupsEditModal){
        this.editMode = false;
        this.groupId == ''
        this.groupName = ''
        this.groupMethod = 100
        this.groupModel = 200
        this.groupType = 300
      }
    },
    editGroup(group){
      this.switchGroupsEditModalState()

      this.editMode = true;
      this.groupId = group.id

      this.groupName = group.name
      this.groupMethod = group.method
      this.groupModel = group.model
      this.groupType = group.type
    },
    changeGroup() {
      this.$http
        .put(`/settings/${this.groupId}/`, {
          name: this.groupName,
          method: this.groupMethod,
          model: this.groupModel,
          type: this.groupType
        })
        .then(response => {
          console.log(`Adding group`)
          if(response.status === 200){
            this.switchGroupsEditModalState();
            this.groupName = null;
            this.loadData();
          }
        })
        .catch(error => {
          this.groupAddErrorMessage = error;
          setTimeout(()=>{
            this.groupAddErrorMessage = '';
          }, 3000)
          console.log('Error in group edit', error);
        })
    },
    addGroup() {
      this.$http
        .post(`/settings/`, {
          name: this.groupName,
          method: this.groupMethod,
          model: this.groupModel,
          type: this.groupType
        })
        .then(response => {
          console.log(`Adding group`)
          if(response.status === 200){
            this.groups.push(response.data);
            this.switchGroupsEditModalState();
            this.groupName = null;
          }
        })
        .catch(error => {
          this.groupAddErrorMessage = 'Группа с таким названием уже создана';
          setTimeout(()=>{
            this.groupAddErrorMessage = '';
          }, 3000)
          console.log('Error in group edit', error);
        })
    },
    deleteGroup(id) {
      this.$http
        .delete(`/settings/${id}/?type=group`)  
        .then(response => {
          if(response.status === 200){
            this.groups = this.groups.filter((group) => {
              return group.id !== id
            })
          }
        })
        .catch(error => {
          console.log('Error in group delete', error);
        })
    },
    declineTemplate(id) {
      this.$http
        .delete(`/settings/${id}/?type=template`)
        .then(response => {
          if(response.status === 200){
            this.templates = this.templates.filter((template) => {
              return template.id !== id
            })
          }
        })
        .catch(error => {
          console.log('Error in template decline', error);
        })
    }
  }
}
</script>

<style scoped>
.body {
  margin-top: 5.2rem;
}

.title {
  font-size: 1.3rem;
  color: #3ebaff;
  padding: 1rem 1rem 0.5rem 2rem;
}

.block {
  background-color: #ffffff;
  box-shadow: 5px 5px 5px #e0e0e0;
  padding: 1rem;
  margin: 0 1rem 1rem 1rem;
  border: 1px solid #c0c0c0;
  border-radius: 5px;
}

table {
  border-collapse: collapse;
  margin: 1rem 0;
}

tr.data-row:nth-child(odd) {
  background-color: #d5e2ef;
}

th {
  padding: 0.2rem 0.5rem;
  border: 1px solid #aaa;
  font-size: 0.9rem;
  overflow-wrap: anywhere;
  color: #0074B5;
}

td {
  padding: 0.3rem;
  border: 1px solid #aaa;
  text-align: left;
  font-size: 0.8rem;
  overflow-wrap: anywhere;
  text-align: center;
}

td.period {
  text-align: center;
  min-width: 8rem;
  max-width: 8rem;
}

td.check {
  text-align: center;
}

td span {
  font-size: 0.8rem;
}

.modal-group-name-input{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  margin-top: 1rem;
}

.td-centered {
  text-align: center;
}
</style>
